import { useEffect, useState } from 'react';

export const useTheme = () => {
  // Check local storage first, default to 'dark' since it's your app's default
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('buniverse-theme') || 'dark';
  });

  useEffect(() => {
    const root = document.documentElement;

    const applyTheme = (selectedTheme) => {
      if (selectedTheme === 'system') {
        // Check the operating system's preference
        const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        root.setAttribute('data-theme', systemPrefersDark ? 'dark' : 'light');
      } else {
        root.setAttribute('data-theme', selectedTheme);
      }
    };

    applyTheme(theme);
    localStorage.setItem('buniverse-theme', theme);

    // Listen for OS-level theme changes dynamically if "system" is selected
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      if (theme === 'system') applyTheme('system');
    };
    
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [theme]);

  return [theme, setTheme];
};